<template>
  <div class="commission-page common-bg">
    <div class="commission-header">
      <div class="header-left">
        <span class="header-label">结算周期</span>
        <span class="header-value">日结</span>
      </div>
      <div class="header-right">
        <span class="header-label">距离下次结算</span>
        <span class="header-value">0天12:08:57</span>
      </div>
    </div>

    <div class="date-selector" @click="showFilter = true">
      <div class="selector-btn">
        <span>{{ currentDateText }}</span>
        <van-icon name="arrow-down" class="arrow-icon" />
      </div>
    </div>

    <div class="empty-state" v-if="commissionList.length === 0">
      <div class="empty-icon-wrap">
        <img src="/static/image/img_none_sj.avif" class="empty-icon" alt="" />
      </div>
      <div class="empty-text">今日暂无记录，<span class="empty-link">可查看更多</span></div>
    </div>

    <div class="commission-list" v-else>
      <div class="list-item" v-for="(item, index) in commissionList" :key="index">
        <div class="item-left">
          <div class="item-time">{{ item.time }}</div>
          <div class="item-type">{{ item.type }}</div>
        </div>
        <div class="item-amount">{{ item.amount }}</div>
      </div>
    </div>

    <!-- 筛选弹窗 -->
    <div class="filter-overlay" v-if="showFilter" @click="showFilter = false"></div>
    <div class="filter-dropdown" v-if="showFilter">
      <div class="filter-content">
        <div class="filter-tabs">
          <div class="filter-tab" v-for="(item, index) in dateOptions" :key="index" :class="{ active: activeDateTab === item.value }" @click="selectDate(item.value)">
            {{ item.text }}
          </div>
        </div>
        <div class="custom-date">
          <div class="custom-title">自定义</div>
          <div class="date-inputs">
            <div class="date-input-box">
              <div class="date-label">开始日期</div>
              <div class="date-picker">
                <span class="date-num">{{ startDate.month }}</span>
                <span class="date-num">{{ startDate.day }}</span>
                <span class="date-year">{{ startDate.year }}</span>
              </div>
            </div>
            <div class="date-input-box">
              <div class="date-label">结束日期</div>
              <div class="date-picker">
                <span class="date-num">{{ endDate.month }}</span>
                <span class="date-num">{{ endDate.day }}</span>
                <span class="date-year">{{ endDate.year }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="filter-btns">
          <div class="filter-btn cancel" @click="showFilter = false">取消</div>
          <div class="filter-btn confirm" @click="confirmFilter">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'promoteCommission',
  data() {
    return {
      showFilter: false,
      activeDateTab: 0,
      dateOptions: [
        { text: '今日', value: 0 },
        { text: '昨日', value: 1 },
        { text: '本周', value: 2 },
        { text: '上周', value: 3 },
        { text: '本月', value: 4 },
        { text: '上月', value: 5 },
        { text: '全部', value: 6 },
      ],
      startDate: { year: '2026', month: '07', day: '07' },
      endDate: { year: '2026', month: '07', day: '07' },
      commissionList: [],
    };
  },
  computed: {
    currentDateText() {
      const item = this.dateOptions.find(i => i.value === this.activeDateTab);
      return item ? item.text : '今日';
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      let that = this;
    },
    selectDate(value) {
      this.activeDateTab = value;
    },
    confirmFilter() {
      this.showFilter = false;
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../static/css/common.css';

.commission-page {
  min-height: 100vh;
  background: #1E1F24;
  padding: 0.2rem;
  box-sizing: border-box;
}

.commission-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 0.2rem;
  background: #292A2C;
  border-radius: 0.12rem;
  margin-bottom: 0.2rem;

  .header-left,
  .header-right {
    display: flex;
    align-items: center;
    gap: 0.1rem;
  }

  .header-label {
    font-size: 0.24rem;
    color: #888;
  }

  .header-value {
    font-size: 0.26rem;
    color: #DFB372;
  }
}

.date-selector {
  margin-bottom: 0.2rem;

  .selector-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.1rem;
    padding: 0.12rem 0.25rem;
    background: #292A2C;
    border: 1px solid #3B3C3D;
    border-radius: 0.3rem;
    color: #fff;
    font-size: 0.26rem;

    .arrow-icon {
      color: #888;
      font-size: 0.2rem;
    }
  }
}

.empty-state {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 0;

  .empty-icon-wrap {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.4rem;

    .empty-icon {
      width: 2.5rem;
      height: 2.5rem;
      opacity: 0.5;
    }
  }

  .empty-text {
    font-size: 0.28rem;
    color: #666;

    .empty-link {
      color: #DFB372;
    }
  }
}

.commission-list {
  padding: 0.2rem;

  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.3rem 0.25rem;
    background: #292A2C;
    border: 1px solid #3B3C3D;
    border-radius: 0.12rem;
    margin-bottom: 0.15rem;

    .item-left {
      .item-time {
        font-size: 0.24rem;
        color: #888;
        margin-bottom: 0.08rem;
      }

      .item-type {
        font-size: 0.28rem;
        color: #fff;
      }
    }

    .item-amount {
      font-size: 0.32rem;
      font-weight: bold;
      color: #DFB372;
    }
  }
}

.filter-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
}

.filter-dropdown {
  position: fixed;
  top: 4.6rem;
  left: 0;
  right: 0;
  background: #1E1F24;
  z-index: 100;
  padding: 0.25rem;
  border-bottom-left-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;

  .filter-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 0.12rem;
    margin-bottom: 0.25rem;

    .filter-tab {
      width: calc(33.333% - 0.08rem);
      text-align: center;
      padding: 0.18rem 0;
      background: #292A2C;
      border: 1px solid #3B3C3D;
      border-radius: 0.12rem;
      color: #fff;
      font-size: 0.28rem;

      &.active {
        color: #DFB372;
        border-color: #DFB372;
      }
    }
  }

  .custom-date {
    margin-bottom: 0.25rem;

    .custom-title {
      font-size: 0.26rem;
      color: #fff;
      margin-bottom: 0.15rem;
    }

    .date-inputs {
      display: flex;
      gap: 0.2rem;

      .date-input-box {
        flex: 1;
        background: #292A2C;
        border: 1px solid #3B3C3D;
        border-radius: 0.12rem;
        padding: 0.2rem;

        .date-label {
          font-size: 0.24rem;
          color: #888;
          text-align: center;
          margin-bottom: 0.15rem;
        }

        .date-picker {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 0.15rem;

          .date-num {
            font-size: 0.32rem;
            color: #fff;
            font-weight: bold;
          }

          .date-year {
            font-size: 0.24rem;
            color: #888;
          }
        }
      }
    }
  }

  .filter-btns {
    display: flex;
    gap: 0.2rem;

    .filter-btn {
      flex: 1;
      text-align: center;
      padding: 0.2rem 0;
      border-radius: 0.3rem;
      font-size: 0.3rem;

      &.cancel {
        color: #DFB372;
        border: 1px solid #DFB372;
        background: transparent;
      }

      &.confirm {
        color: #333;
        background: linear-gradient(90deg, #f3ca8e 0%, #dfb372 100%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/component/promote/Commission.vue